define('validatorhelpers',[], function() {
    'use strict';

    return {
        /**
         * Checks if each key is set in the ADL. Returns the array of missing keys.
         *
         * @param {ADL} [adl] - ADL instance
         * @param {Array} [keys] - Array of property names to check if they are set in the ADL instance
         * @returns {Array} - Array of missing property names
         */
        checkRequiredProperties: function(adl, keys) {
            var missingProps = [],
                i,
                len;

            for (i = 0, len = keys.length; i < len; i++) {
                if (!adl.isSet(keys[i])) {
                    missingProps.push(keys[i]);
                }
            }

            return missingProps;
        }
    };
});

